import { render, staticRenderFns } from "./Index_m.vue?vue&type=template&id=fcf42720&scoped=true"
import script from "./Index_m.vue?vue&type=script&lang=js"
export * from "./Index_m.vue?vue&type=script&lang=js"
import style0 from "./Index_m.vue?vue&type=style&index=0&id=fcf42720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf42720",
  null
  
)

export default component.exports